export const GET_VENDER_REQUEST = "GET_VENDER_REQUEST"
export const GET_VENDER_SUCCESS = "GET_VENDER_SUCCESS"
export const CLEAR_REPONSE = "CLEAR_REPONSE"

export const LIKE_VENDER_REQUEST = "LIKE_VENDER_REQUEST"
export const LIKE_VENDER_SUCCESS = "LIKE_VENDER_SUCCESS"
